import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Panel = styled(Grid)`
  border-top-left-radius: ${({ theme }) => theme.x2spacePx}px;
  border-top-right-radius: ${({ theme }) => theme.x2spacePx}px;
  background: ${({ theme }) => theme.color.noir};
`;
